/**
 * Hero Section 데이터
 */
export const HERO_DATA = {
  title: {
    main: '보이지 않는 이들에게 ',
    highlight: '조명을',
  },
  subtitle: 'Castar에서 배우와 제작자가 만납니다.\n당신의 이야기를 시작하세요.',
  cta: {
    primary: {
      label: '바로 시작하기',
      action: '/signup',
      variant: 'primary',
    },
    secondary: {
      label: '공고 둘러보기',
      action: '/castings',
      variant: 'secondary',
      icon: 'search',
    },
  },
  visual: {
    image: '/assets/images/hero-light.png',
    alt: '조명',
  },
};

/**
 * Statistics Section 데이터
 */
export const STATISTICS_DATA = [
  {
    id: 'actors',
    value: '10,000+',
    label: '등록 배우',
    emphasis: true,
  },
  {
    id: 'producers',
    value: '500+',
    label: '제작자',
    emphasis: false,
  },
  {
    id: 'casting-success',
    value: '2,000+',
    label: '캐스팅 성공',
    emphasis: false,
  },
  {
    id: 'funded-projects',
    value: '150+',
    label: '펀딩 프로젝트',
    emphasis: false,
  },
];

/**
 * Features Section 데이터
 */
export const FEATURES_DATA = {
  header: {
    title: '왜 Castar 인가요?',
    subtitle: '캐스팅의 모든 과정을 더 쉽고, 더 빠르게',
  },
  features: [
    {
      id: 'schedule',
      icon: 'calendar',
      title: '일정 관리',
      subtitle: '다가오는 일정',
      type: 'schedule',
      active: false,
    },
    {
      id: 'audition',
      icon: 'megaphone',
      title: '다양한 공고',
      subtitle: '실시간 공고 공고',
      type: 'audition',
      active: false,
    },
    {
      id: 'actor-db',
      icon: 'user',
      title: '검증된 배우 DB',
      subtitle: '프로필 검색 및 추천',
      type: 'actor-db',
      active: false,
    },
    {
      id: 'communication',
      icon: 'message',
      title: '원활한 소통',
      subtitle: '최근 대화',
      type: 'communication',
      active: false,
    },
  ],
};

/**
 * Auditions Section 데이터
 */
export const AUDITIONS_DATA = {
  header: {
    title: '진행 중인 공고',
    subtitle: '지금 바로 지원할 수 있는 공고을 확인하세요.',
    // action: {
    //   label: '전체 보기',
    //   path: '/auditions',
    // },
  },
  auditions: [
    {
      id: 'aud-001',
      category: '드라마',
      location: '서울',
      dDay: 'D-7',
      title: '넷플릭스 오리지널 드라마',
      company: '스튜디오드래곤',
      role: '여주인공',
    },
    {
      id: 'aud-002',
      category: '광고',
      location: '1종',
      dDay: 'D-14',
      title: '글로벌 뷰티 브랜드 광고',
      company: '제일기획',
      role: '메인 모델',
    },
    {
      id: 'aud-003',
      category: '영화',
      location: '부산',
      dDay: 'D-21',
      title: '독립영화 장편',
      company: '인디필름',
      role: '조연',
    },
  ],
};

/**
 * CTA Section 데이터
 */
export const CTA_DATA = {
  background: {
    src: '/assets/images/cta-curtain.jpg', // 실제 운영 시 이 경로만 교체
    alt: '무대 커튼',
  },
  title: '지금 바로 시작하세요!',
  subtitle:
    '배우라면 새로운 기회를, 제작사라면 완벽한 캐스팅을.\nCastar가 당신의 다음 이야기를 함께합니다.',
  buttons: {
    actor: {
      label: '배우로 가입하기',
      action: '/signup',
      variant: 'primary',
      icon: 'user',
    },
    producer: {
      label: '제작사로 가입하기',
      action: '/signup',
      variant: 'dark',
      icon: 'arrow',
    },
  },
};

/**
 * SpotlightActors Section 데이터s
 */
export const SPOTLIGHT_ACTORS_DATA = {
  header: {
    title: '주목할 배우',
    subtitle: '검증된 배우들의 프로필을 확인하세요.',
    action: {
      label: '전체 보기',
      path: '/actors',
    },
  },
  actors: [
    {
      id: 'actor-001',
      name: '김민지',
      gender: '여성',
      age: 24,
      height: 168,
      skills: ['연기', '노래'],
      image: null,
    },
    {
      id: 'actor-002',
      name: '이준호',
      gender: '남성',
      age: 28,
      height: 182,
      skills: ['연기', '액션'],
      image: null,
    },
    {
      id: 'actor-003',
      name: '박서연',
      gender: '여성',
      age: 22,
      height: 165,
      skills: ['연기', '댄스'],
      image: null,
    },
    {
      id: 'actor-004',
      name: '최우진',
      gender: '남성',
      age: 30,
      height: 178,
      skills: ['연기', '무술'],
      image: null,
    },
  ],
};
